import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import {
  importCSVFile,
  importHighRiskSupplementsListCSVFile,
  importSynonymsListCSVFile,
} from '@api/medications';
import {
  IImportHighRiskSupplementsListResponse,
  IImportMedicationsResponse,
  IImportSynonymsListResponse,
} from '@interfaces/medications';

export const handleAdminImportMedications = createAsyncThunk<
  AxiosResponse<IImportMedicationsResponse>,
  { file: File }
>('adminImportMedications', ({ file }) => importCSVFile(file));

export const handleAdminImportSynonymsList = createAsyncThunk<
  AxiosResponse<IImportSynonymsListResponse>,
  { file: File }
>('adminImportSynonymsList', ({ file }) => importSynonymsListCSVFile(file));

export const handleAdminHighRiskSupplementsList = createAsyncThunk<
  AxiosResponse<IImportHighRiskSupplementsListResponse>,
  { file: File }
>('adminImportRiskSupplementsList', ({ file }) => importHighRiskSupplementsListCSVFile(file));
